/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * An enumeration of selection modes.
 *
 * [[include:absdk/commons/ui/input/AbSelectionMode.md]]
 */
export let AbSelectionMode = /*#__PURE__*/function (AbSelectionMode) {
  AbSelectionMode["SINGLE"] = "single";
  AbSelectionMode["MULTIPLE"] = "multiple";
  AbSelectionMode["NONE"] = "none";
  return AbSelectionMode;
}({});
//# sourceMappingURL=AbSelectionMode.js.map
